/* eslint-disable @typescript-eslint/naming-convention */
import {
  Component,
  Input,
  OnInit,
  OnChanges,
  ChangeDetectorRef,
  HostListener,
  AfterViewChecked,
} from '@angular/core';
import { EChartOptions, SelectionsObj } from '../../util/util';
@Component({
  selector: 'cigna-common-bar-charts',
  templateUrl: './common-bar-charts.component.html',
  styleUrls: ['./common-bar-charts.component.scss'],
})
export class CommonBarChartsComponent
  implements OnInit, OnChanges, AfterViewChecked
{
  @Input() eChartOptions?: EChartOptions;
  resultsData: SelectionsObj[];
  view?: number[];

  // options
  showXAxis?: boolean;
  showYAxis?: boolean;
  gradient?: boolean;
  showLegend?: boolean;
  showXAxisLabel?: boolean;
  xAxisLabel?: string;
  showYAxisLabel?: boolean;
  yAxisLabel?: string;
  legendPosition?: string;
  showGridLines?: boolean;
  animations?: boolean;
  allowYAxisTickFormatting?: any;
  roundEdges?: boolean;
  colorScheme = { domain: ['#014986', '#d9d9d9'] };
  getScreenWidth: number;
  barPadding: number;

  constructor(private cdr: ChangeDetectorRef) {}
  @HostListener('window:resize', ['$event'])
  getChartSize(): void {
    this.getScreenWidth =
      (() => {
        switch (this.eChartOptions?.chartType) {
          case 'bar':
            return document.querySelectorAll(
              'ngx-charts-bar-vertical-stacked',
            )[0]?.parentElement?.offsetWidth;
            break;
          case 'singleSeriesBar':
            return document.querySelectorAll('ngx-charts-bar-vertical')[0]
              ?.parentElement?.offsetWidth;
            break;
          default:
            return 0;
        }
      })() || 0;
    this.view = [this.getScreenWidth * 0.95, 250];
    this.showYAxis = this.eChartOptions?.showYAxis;

    this.cdr.detectChanges();
  }
  ngAfterViewChecked(): void {
    if (!this.getScreenWidth) {
      this.getChartSize();
    }
  }
  ngOnInit(): void {}
  ngOnChanges(changes: ComponentChanges<this>) {
    if (this.eChartOptions && changes.eChartOptions?.currentValue) {
      this.resultsData = this.eChartOptions.results;
      this.view = this.eChartOptions.view;
      this.showXAxis = this.eChartOptions.showXAxis;
      this.showYAxis = this.eChartOptions.showYAxis;
      this.gradient = this.eChartOptions.gradient;
      this.showLegend = this.eChartOptions.showLegend;
      this.showXAxisLabel = this.eChartOptions.showXAxisLabel;
      this.xAxisLabel = this.eChartOptions.xAxisLabel;
      this.showYAxisLabel = this.eChartOptions.showYAxisLabel;
      this.yAxisLabel = this.eChartOptions.yAxisLabel;
      this.legendPosition = this.eChartOptions.legendPosition;
      this.showGridLines = this.eChartOptions.showGridLines;
      this.animations = this.eChartOptions.animations;
      this.roundEdges = this.eChartOptions.roundEdges;
      this.allowYAxisTickFormatting =
        this.eChartOptions.allowYAxisTickFormatting;
      this.colorScheme.domain = this.eChartOptions.domain || [
        '#014986',
        '#d9d9d9',
      ];
      this.barPadding = this.eChartOptions.barPadding || 0;
    }
  }
}
